<script>
export default {
  props: {
    href: String,
    type: [Array, String],
    blank: Boolean,
  },
};
</script>

<template>
  <a
    :class="[type]"
    class="f-link"
    :href="href"
    :target="blank ? '_blank' : ''"
  >
    <slot></slot>
  </a>
</template>

<style lang="scss">
a.f-link {
  display: flex;
  color: #1890d3;
  padding: 0;
  text-transform: none;
  font-family: Lato;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 14px;
  text-decoration: none;
  gap: 6px;

  &:hover {
    text-decoration: underline;
  }

  &.small {
    font-size: 12px;
  }

  &.large {
    font-size: 16px;
  }
}

.dark-mode {
  a.f-link {
    color: var(--navigation);
  }
}
</style>